import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pageNumberInfo } from '../../../redux/actions';


const Pagination = ({ resetPage, handleResetPageNo }) => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0)
  const tabNameInformation = useSelector((state) => state.paginationData.pagination)
  const itemsPerPage = useSelector((state) => state.paginationData.dataInOnePage)
  const totalNumberOfResult = useSelector((state) => state.paginationData.totalNumberOfResult)


  const totalPagesToShow = 5; // Fixed number of pages to display if there is Max Pages

  const totalPages = Math.ceil(totalItems / itemsPerPage);


  useEffect(() => {
    if (resetPage) {
      setCurrentPage(1);
      handleResetPageNo();
    }
  }, [resetPage, handleResetPageNo]);


  useEffect(() => {

    setTotalItems(totalNumberOfResult)

  }, [totalNumberOfResult])

  useEffect(() => {
    setCurrentPage(1)
  }, [tabNameInformation])


  useEffect(() => {
    dispatch(pageNumberInfo(currentPage))
  }, [currentPage])


  const goToPreviousPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const goToNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const firstPageNumber = Math.max(currentPage - Math.floor(totalPagesToShow / 2), 1);
  const lastPageNumber = Math.min(firstPageNumber + totalPagesToShow - 1, totalPages);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = firstPageNumber; i <= lastPageNumber; i++) {
      pageNumbers.push(
        <div key={i} className={`pagination-number ${currentPage === i ? 'active' : ''}`} onClick={() => setCurrentPage(i)}>
          {i}
        </div>
      );
    }
    return pageNumbers;
  };

  return (

    <div className="pagination">
      {totalItems > 0 ? <div
        className="pagination-arrow left-arrow"
        style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }} onClick={goToPreviousPage}>
        &lt;&lt;
      </div> : ""}
      <div className="pagination-numbers">
        {renderPageNumbers()}
      </div>
      {totalItems > 0 ? <div className="pagination-arrow right-arrow" style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
        onClick={goToNextPage}>
        &gt;&gt;
      </div> : ""}
    </div>
  );
};

export default Pagination;





